import axios from 'axios';
import { useState, useEffect, useContext } from 'react';

import { MyContext } from '../../Store';
import { trans, hash } from '../../utils';
import { Modal } from './Modal';

const STATUS_ENUM = {
  pdfLoading: 0,
  pdfDownloading: 1,
  pdfError: 2,
};

export const DownloadModal = () => {
  const [state, dispatch] = useContext(MyContext);

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(STATUS_ENUM.pdfLoading);

  const handleDownload = () => {
    setIsDownloadModalOpen(true);
    getPdfData(hash());
  };

  const getPdfData = async (orderHash, retryCount = 0) => {
    const MAX_RETRIES = 10;
    const RETRY_DELAY = 1250;

    try {
      await axios.post(`/api/generate_pdf/${orderHash}`);
    } catch (error) {
      console.error('Error initiating PDF generation:', error);
      setCurrentStatus(STATUS_ENUM.pdfError);
      return;
    }

    try {
      const response = await axios.get(`/api/generating_pdf_status/${orderHash}`);

      if (response.data.pdf_in_progress) {
        if (retryCount < MAX_RETRIES) {
          setTimeout(() => getPdfData(orderHash, retryCount + 1), RETRY_DELAY);
        } else {
          console.error('PDF generation timeout reached');
          setCurrentStatus(STATUS_ENUM.pdfError);
        }
      } else {
        dispatch({ type: 'SET_PDF_URL', payload: response.data.pdf_url });
        setCurrentStatus(STATUS_ENUM.pdfDownloading);
      }
    } catch (error) {
      console.error('Error checking PDF generation status:', error);
      setCurrentStatus(STATUS_ENUM.pdfError);
    }
  };

  const handleClose = () => setIsDownloadModalOpen(false);

  const PdfLoader = (
    <div className="w-100">
      <div style={{ margin: '10px 0' }}>
        <i className="fas fa-2xl fa-circle-notch fa-spin"></i>
      </div>
      <div>
        <p>{trans('Proszę czekać trwa generowanie pliku PDF...')}</p>
      </div>
    </div>
  );

  const PdfDownload = (
    <div className="w-100">
      <div>
        <p style={{ margin: '1.75rem 0' }}>
          <i className="fa-solid fa-2x fa-file-pdf" style={{ color: '#d70606', marginBottom: '10px' }}></i>
          <br />
          <a target="_blank" rel="noopener noreferrer" href={`${state.pdfUrl}?${Date.now()}`} download>
            <b>{trans('Kliknij tutaj')}</b>
          </a>{' '}
          {trans('aby pobrać projekt w formacie pdf')}
        </p>
      </div>
    </div>
  );

  const ErrorMsg = (
    <div className="w-100">
      <div>
        <p>{trans('Przepraszamy!')}</p>
        <p>
          {trans('Wystąpił błąd podczas generowania pliku PDF, prosimy o ponownę próbę lub kontakt z administratorem.')}
        </p>
      </div>
      <div className="form-group btn-group">
        <button onClick={() => setIsDownloadModalOpen(false)} type="button" className="btn confirm-btn">
          OK
        </button>
      </div>
    </div>
  );

  const ORDER_FORM_STAGE_MAP = {
    [STATUS_ENUM.pdfLoading]: PdfLoader,
    [STATUS_ENUM.pdfDownloading]: PdfDownload,
    [STATUS_ENUM.pdfError]: ErrorMsg,
  };

  useEffect(() => {
    if (isDownloadModalOpen === false) {
      setCurrentStatus(STATUS_ENUM.pdfLoading);
    }
  }, [isDownloadModalOpen]);

  return (
    <>
      <button className="btn download-btn order-btn" onClick={handleDownload}>
        {trans('Pobierz')}
      </button>

      {isDownloadModalOpen && (
        <Modal handleClose={() => handleClose()} title={trans('Pobieranie PDF')}>
          {ORDER_FORM_STAGE_MAP[currentStatus]}
        </Modal>
      )}
    </>
  );
};
